import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutateFunction,
} from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { catalogAccessRepository } from '@webapp/modules/purchasing/data-access/repositories/CatalogAccessRepository'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'
import { type V1User } from '@webapp/platform/iam'

interface SaveSecondaryCategoryGrantsPayload {
  secondaryCategoryId: number
  userIds: number[]
}

interface UseAssignUsersToSecondaryCategoryModelReturn {
  mutate: UseMutateFunction<void, RepoError, SaveSecondaryCategoryGrantsPayload>
  isLoading: boolean
  isOptionsLoading: boolean
  userOptions: V1User[]
}

export const useAssignUsersToSecondaryCategoryModel =
  (): UseAssignUsersToSecondaryCategoryModelReturn => {
    const queryClient = useQueryClient()

    const { data: formDefaults, isLoading: isOptionsLoading } = useQuery(
      catalogAccessQueryConfig.secondaryCategoryAccessFormDefaults()
    )

    const userOptions = formDefaults?.userOptions ?? []

    const { mutate, isLoading } = useMutation<
      void,
      RepoError,
      SaveSecondaryCategoryGrantsPayload
    >({
      mutationFn: ({
        secondaryCategoryId,
        userIds,
      }: SaveSecondaryCategoryGrantsPayload) =>
        catalogAccessRepository.saveSecondaryCategoryGrants(
          secondaryCategoryId,
          userIds
        ),
      onSuccess: () => {
        queryClient.invalidateQueries(
          catalogAccessQueryConfig.secondaryCategoryConfigs().queryKey
        )
      },
    })

    return {
      mutate,
      isLoading,
      isOptionsLoading,
      userOptions,
    }
  }
